<template>
  <v-layout column id="resultDiv">
    <v-container class="xs12 text-xs-center title font-weight-bold guid-success">
      <img class="pt-3" width="180px" src="@/assets/art/upload-complete-checkmark.svg" alt="Upload Complete"/>
      <span>{{$t('qrCode.photosUploaded')}}</span>
      <h2>{{$t('qrCode.completeAtKiosk')}}</h2>
    </v-container>
    <div class="divider-flat"></div>
    <v-container flex-column align-center justify-center px-0>
      <span>{{$t('qrCode.dontSeePhotos')}}</span>
      <button class="clickable-text" @click="$emit('getUserCode')">{{$t('qrCode.tapHere')}}</button>
    </v-container>
  </v-layout>
</template>

<script>
export default {
  name: 'GuidTransferComplete',
  emits: ['getUserCode']
}
</script>

<style>
.guid-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  line-height: 1.2 !important;
  letter-spacing: -0.5px !important;
}
</style>
